var ShowMoreLessController = /** @class */ (function () {
    function ShowMoreLessController($sce, googleAnalytic) {
        'ngInject';
        this.ga = googleAnalytic;
        this.$sce = $sce;
        this.showMoreDesc = false;
    }
    ShowMoreLessController.prototype.trustAsHtml = function (data) {
        return this.$sce.trustAsHtml(data);
    };
    ShowMoreLessController.prototype.changeLimit = function () {
        if (this.gaCategory && this.gaAction)
            this.ga.sendEvent(this.gaCategory, this.gaAction, this.showMoreDesc ? "show less clicked" : "show more clicked", 1);
        this.showMoreDesc = this.showMoreDesc ? false : true;
    };
    return ShowMoreLessController;
}());
export default ShowMoreLessController;
;
//# sourceMappingURL=show-more-less.controller.js.map